import axios from 'axios'
import {
  MonthlySpendResponse,
  SixMonthSpendByCurrencyResponse,
  SixMonthSpendResponse,
} from 'src/queries/charts/monthlySpend/monthlySpend.models'
import { getResponseData } from 'src/queries/network.utils'
import { getRequestConfig, RequestConfig } from 'src/queries/requestConfig'

export const getMonthlySpend = async (): Promise<MonthlySpendResponse> => {
  return getResponseData(
    axios.get<MonthlySpendResponse>(
      '/charts/monthlyspend',
      getRequestConfig(RequestConfig.Default),
    ),
  )
}

export const getSixMonthSpend = async (): Promise<SixMonthSpendResponse> => {
  return getResponseData(
    axios.get<SixMonthSpendResponse>(
      '/charts/sixmonthspend',
      getRequestConfig(RequestConfig.Default),
    ),
  )
}

export const getSixMonthSpendByCurrency =
  async (): Promise<SixMonthSpendByCurrencyResponse> => {
    return getResponseData(
      axios.get<SixMonthSpendByCurrencyResponse>(
        '/charts/sixmonthspendbycurrency',
        getRequestConfig(RequestConfig.Default),
      ),
    )
  }
